import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconPropertyTownhouseSvg } from "./IconPropertyTownhouseSvg.mjs";
const IconPropertyTownhouse = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconPropertyTownhouseSvg, ...iconProps });
};
export {
  IconPropertyTownhouse
};
